import { render, staticRenderFns } from "./orderNote.vue?vue&type=template&id=c5a104c0&scoped=true"
import script from "./orderNote.vue?vue&type=script&lang=js"
export * from "./orderNote.vue?vue&type=script&lang=js"
import style0 from "./orderNote.vue?vue&type=style&index=0&id=c5a104c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a104c0",
  null
  
)

export default component.exports